import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const applicationLendersInfoApi = async (appId, applicationId) => {
  try {
    const requestBody = {
      appId: appId,
      applicationId: applicationId,
    };

    const apiLink = `${endpoint}/api/ext-lenders-list`;
    const response = await axios.post(apiLink, requestBody);
    const data = response.data;

    const dataObject = {};

    if (data && data.data) {
      data.data.forEach((elem) => {
        dataObject[elem.slug.toLowerCase().replace("-", "")] = {
          name: elem.name || "",
          defaultUrl: elem.website || "",
          downloadLink: elem.download_link || "",
          logo: elem.logo || "",
          id: elem.lender_id || null,
          otp: elem.website === "otp",
          gold_loan: !!elem.gold_loan,
          message: elem.message || "",
        };
      });
    }
    return dataObject;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default applicationLendersInfoApi;
